module.exports = __webpack_public_path__ + "img/big-truck.97ed8f50.svg";